import React from 'react';
import { Download, FileText } from 'lucide-react';
import { categories, products } from '../data/mock';

const Datasheets = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-slate-900 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="text-5xl font-bold text-white mb-6">
            Technical Datasheets
          </h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Download comprehensive technical documentation for all EVERKAST NZ products
          </p>
        </div>
        {/* Optional gradient behind header */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 to-transparent pointer-events-none -z-10"></div>
      </section>

      {/* Datasheets by Category */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {categories.map((category) => {
            const categoryProducts = products.filter(p => p.category === category.slug);
            return (
              <div key={category.id} className="mb-20">
                <div className="mb-8">
                  <h2 className="text-3xl font-bold text-slate-900 mb-2">{category.name}</h2>
                  <p className="text-slate-600">{category.description}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {categoryProducts.map((product) => (
                    <div
                      key={product.id}
                      className="relative bg-white rounded-3xl p-6 shadow-2xl hover:shadow-2xl hover:scale-105 transition-transform duration-300"
                    >
                      <div className="flex items-start space-x-4">
                        <div className="w-16 h-16 bg-slate-100 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
                          <FileText className="w-8 h-8 text-slate-900" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-bold text-slate-900 mb-2 text-lg">{product.name}</h3>
                          <p className="text-sm text-slate-600 mb-4 line-clamp-2">
                            {product.shortDescription}
                          </p>
                          <button
                            onClick={() => window.open(product.technicalSheet, '_blank')}
                            className="inline-flex items-center text-slate-900 hover:text-slate-700 font-semibold text-sm group"
                          >
                            <Download className="w-4 h-4 mr-2 group-hover:translate-y-0.5 transition-transform" />
                            Download TDS
                          </button>
                        </div>
                      </div>

                      {/* Optional floating accent behind card */}
                      <div className="absolute -inset-1 rounded-3xl bg-gradient-to-r from-green-100 via-green-50 to-green-100 -z-10 pointer-events-none"></div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">
            Need Additional Information?
          </h2>
          <p className="text-lg text-slate-600 mb-8">
            Contact us for detailed specifications, application guides, and product consultation
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center px-8 py-4 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-semibold text-lg"
          >
            Contact Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default Datasheets;
